module.exports = __webpack_public_path__ + "static/facebook_copy_address-797bfdbbee162fe11a880f4939c1f778.png";